export const SPACE_LINK = "https://alpar2.sfo3.digitaloceanspaces.com";

export const NOIMAGE_LINK = `${SPACE_LINK}/Alpar/no-image.jpg`;

export const FRONT_LINK = `https://portal.alpardobrasil.com.br`;
